export default __webpack_public_path__ + "a6862bcfb0fba741873c91f140df33cb.png";